import { parse as parseColor } from '@zag-js/color-picker';
import { color } from '@/colors';
import { log } from '@/logger/logger';

const logger = log.getLogger('color.utils');

export function hexToRgbaObject(hex: string): { r: number; g: number; b: number; a: number } {
  let r = 0,
    g = 0,
    b = 0,
    a = 1;
  // 6 digits
  if (hex.length === 7) {
    r = parseInt(hex[1] + hex[2], 16);
    g = parseInt(hex[3] + hex[4], 16);
    b = parseInt(hex[5] + hex[6], 16);
  }
  // 8 digits
  else if (hex.length === 9) {
    r = parseInt(hex[1] + hex[2], 16);
    g = parseInt(hex[3] + hex[4], 16);
    b = parseInt(hex[5] + hex[6], 16);
    a = parseInt(hex[7] + hex[8], 16) / 255;
  } else {
    logger.warn('Invalid hex color', { hex });
  }
  return { r, g, b, a };
}

function luminance(colorValue: string): number {
  const parsed = parseColor(colorValue);
  const r = parsed.getChannelValue('red');
  const g = parsed.getChannelValue('green');
  const b = parsed.getChannelValue('blue');

  const a = [r, g, b].map((v) => {
    v /= 255;
    return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
  });

  return 0.2126 * a[0] + 0.7152 * a[1] + 0.0722 * a[2];
}

export const getContrastedTextColorFromHex = (colorValue: string) => {
  const L = luminance(colorValue);

  const contrastWhite = 1.05 / (L + 0.05);
  const contrastBlack = (L + 0.05) / 0.05;

  const textColor = contrastWhite > contrastBlack ? color.White100 : color.Black100;
  const placeholderColor = contrastWhite > contrastBlack ? color.White40_T : color.Black40_T;
  return { textColor, placeholderColor };
};

export const hexToRgbaWithAlpha = (colorValue: string, opacity: number): string | null => {
  try {
    const color = parseColor(colorValue);
    return color.toFormat('rgba').withChannelValue('alpha', opacity).toString('rgba');
  } catch {
    logger.warn('Failed to parse color', { color: colorValue });
    return null;
  }
};
